import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Bar = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
  padding: ${spacing[3]} ${spacing[4]};
  background: ${rawColors.structural.white};
  border-bottom: 1px solid ${rawColors.grey[200]};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing[2]};
  flex-wrap: wrap;
`;

export const RowLabel = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
  white-space: nowrap;
`;

export const PillGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing[2]};
  flex-wrap: wrap;
  flex: 1;
`;

/** Right-aligned cluster: pipeline trigger + Show links toggle. */
export const RightControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing[3]};
  margin-left: auto;
  flex-shrink: 0;
`;

export const ShowLinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing[2]};
`;

export const ShowLinksLabel = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.highEmphasis};
  white-space: nowrap;
`;

/** Compact search, right-aligned inside the groups row in fullscreen mode. */
export const SearchWrapper = styled.div`
  width: 200px;
  flex-shrink: 0;
  margin-left: auto;
`;
